module.exports = __webpack_public_path__ + "f3cf4f3bbc96262974be5388e8bade30.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/taiwantaichi.png
 ** module id = 745
 ** module chunks = 0
 **/